export const getLatestDateString = (
	dateStrings: (string | undefined)[],
): string | null => {
	if (dateStrings.length === 0) return null;

	const filteredDates = dateStrings.filter((d): d is string =>
		Boolean(d && !Number.isNaN(new Date(d).getTime()) && typeof d === "string"),
	);

	if (filteredDates.length === 0) return null;

	const latestDate = filteredDates.reduce((latest, current) =>
		new Date(current).getTime() > new Date(latest).getTime() ? current : latest,
	);

	return new Date(latestDate).toISOString();
};
